// lib/sand-v3/interaction/stoneRects.ts
//
// Reads the [data-stone] DOM anchors and normalizes them to shader uniforms:
// vec4(centerU, centerV, radiusU, radiusV) in [0,1] screen UV (origin top-left,
// v down). The pure normalizer is DOM-free for testability.

export interface RectLike { left: number; top: number; width: number; height: number }

export const MAX_STONES = 8;

export function normalizeStoneRects(
  rects: RectLike[],
  vw: number,
  vh: number,
): { data: Float32Array; count: number } {
  const data = new Float32Array(MAX_STONES * 4);
  const count = Math.min(rects.length, MAX_STONES);
  for (let i = 0; i < count; i++) {
    const r = rects[i];
    data[i * 4 + 0] = (r.left + r.width / 2) / vw;
    data[i * 4 + 1] = (r.top + r.height / 2) / vh;
    data[i * 4 + 2] = (r.width / 2) / vw;
    data[i * 4 + 3] = (r.height / 2) / vh;
  }
  return { data, count };
}

export function readStoneRects(vw: number, vh: number): { data: Float32Array; count: number } {
  const els = Array.from(document.querySelectorAll('[data-stone]'));
  const rects: RectLike[] = els.map((el) => {
    const b = el.getBoundingClientRect();
    return { left: b.left, top: b.top, width: b.width, height: b.height };
  });
  return normalizeStoneRects(rects, vw, vh);
}
